<template>
  <v-footer
    padless
    color="grey lighten-4"
    class="pt-10 pb-10 font-weight-medium mb-15"
  >
    <v-container class="ot-container">
      <v-row class="pt-4 border-top">
        <v-divider class="secondary mb-8" style="width: 100%"></v-divider>

        <v-col cols="12" lg="5" class="mb-4">
          <div class="mb-4">
            <v-img
              @click="$router.push('/two-wheeler-rental/models')"
              src="@/assets/logos/ontrack-logo.png"
              height="auto"
              width="120px"
              contain
              style="cursor: pointer"
            ></v-img>
            <p
              class="grey--text text--darken-2 ot-text-16 font-weight-bold my-4"
            >
              {{ $t("footer_message") }}
            </p>
            <div class="d-flex">
              <v-btn
                icon
                href="https://www.facebook.com/ontrackBikes"
                class="mr-2"
                target="_blank"
              >
                <v-icon color="grey darken-4">mdi-facebook</v-icon>
              </v-btn>
              <v-btn
                icon
                href="https://www.instagram.com/ontrackbikes/"
                class="mr-2"
                target="_blank"
              >
                <v-icon color="grey darken-4">mdi-instagram</v-icon>
              </v-btn>
              <v-btn
                icon
                href="https://www.linkedin.com/company/ontrack-technologies-private-limited/a"
                target="_blank"
              >
                <v-icon color="grey darken-4">mdi-linkedin</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="4" lg="2" class="mb-4">
          <h5 class="text-h6 font-weight-bold mb-3 grey--text text--darken-4">
            {{ $t("learn_more") }}
          </h5>
          <div class="d-flex flex-column">
            <a
              v-for="link in learnLinks"
              :key="link.key"
              :href="link.href"
              target="_blank"
              class="text-decoration-none blue--text text--accent-3 mb-2 font-weight-bold"
            >
              {{ $t(link.key) }}
            </a>
          </div>
        </v-col>

        <v-col cols="12" sm="4" lg="2" class="mb-4">
          <h5 class="text-h6 font-weight-bold mb-3 grey--text text--darken-4">
            {{ $t("policies") }}
          </h5>
          <div class="d-flex flex-column">
            <a
              v-for="link in policyLinks"
              :key="link.key"
              :href="link.href"
              target="_blank"
              class="text-decoration-none blue--text text--accent-3 mb-2 font-weight-bold"
            >
              {{ $t(link.key) }}
            </a>
          </div>
        </v-col>

        <v-col cols="12" sm="4" lg="3" class="mb-4">
          <h5 class="text-h6 font-weight-bold mb-3 grey--text text--darken-4">
            {{ $t("contact_us") }}
          </h5>
          <div class="d-flex flex-column">
            <a
              href="mailto:info@on-track.in"
              class="text-decoration-none blue--text text--accent-3 mb-2 d-flex align-center font-weight-bold"
            >
              <v-icon small color="blue accent-3" class="mr-2"
                >mdi-email-outline</v-icon
              >
              info@on-track.in
            </a>
            <a
              href="tel:9148518401"
              class="text-decoration-none blue--text text--accent-3 mb-2 d-flex align-center font-weight-bold"
            >
              <v-icon small color="blue accent-3" class="mr-2"
                >mdi-phone-outline</v-icon
              >
              +91 91485 18401
            </a>
            <a
              href="https://maps.app.goo.gl/7JeeCTWzBxfTZh2C8"
              target="_blank"
              class="text-decoration-none blue--text text--accent-3 d-flex align-center font-weight-bold"
            >
              <v-icon small color="blue accent-3" class="mr-2"
                >mdi-map-marker-outline</v-icon
              >
              {{ $t("location") }}
            </a>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>
      <v-col cols="12" md="6" class="text-center text-md-left">
        <p class="ot-text-16 font-weight-bold grey--text text--darken-1 mb-0">
          © 2026 {{ $t("company") }}
        </p>
      </v-col>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    learnLinks: [
      { key: "faqs", href: "https://on-track.in/faq" },
      { key: "blog", href: "https://on-track.in/blogs" },
      { key: "stories", href: "https://on-track.in/print_and_media" },
      { key: "about_us", href: "https://on-track.in/about-us" },
      { key: "careers", href: "https://on-track.in/careers" },
      { key: "partner_with_us", href: "https://on-track.in/partner-with-us" },
    ],
    policyLinks: [
      {
        key: "terms_conditions",
        href: "https://on-track.in/terms-and-conditions",
      },
      { key: "privacy_policy", href: "https://on-track.in/privacy-policy" },
      { key: "disclaimer", href: "https://on-track.in/disclaimer-policy" },
      { key: "copyright", href: "https://on-track.in/copyright-guidelines" },
    ],
    //
  }),
};
</script>

<style></style>
